module.exports = __webpack_public_path__ + "media/City-Nights.963ece31.mp4";